import * as React from "react";

function SvgIcons8Android(props, ref) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...{ ...props, ref }}>
      <path d="M10 4c-.523 0-1.059.184-1.438.563C8.184 4.94 8 5.476 8 6v20c0 .523.184 1.059.563 1.438.378.378.914.562 1.437.562h12c.523 0 1.059-.184 1.438-.563.378-.378.562-.914.562-1.437V6c0-.523-.184-1.059-.563-1.438C23.06 4.184 22.523 4 22 4zm0 2h12v20H10zm4 17v2h4v-2z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Android);
